﻿import * as common from "./common";

const colors = ["#FFE699", "#FFD878", "#FFCA5A", "#FFBF42", "#FBB123", "#F8A600", "#F39C00", "#EA8F00", "#E58500", "#DE7C00", "#D77200", "#CF6900", "#CB6200", "#C35900", "#BB5100", "#B54C00", "#B04500", "#A63E00", "#A13700", "#9B3200", "#952D00", "#8E2900", "#882300", "#821E00", "#7B1A00", "#771900", "#701400", "#6A0E00", "#660D00", "#5E0B00", "#5A0A02", "#560A05", "#520907", "#4C0505", "#470606", "#440607", "#3F0708", "#3B0607", "#3A070B", "#36080A"];

var utils = {
    safeRound: function safeRound(num, multiple) {
        if (typeof multiple === "undefined") {
            multiple = 10000;
        }

        return Math.round(num * multiple) / multiple;
    },
    srmToHex: function srmToHex(srm) {

        srm = parseFloat(srm).toFixed(0);

        if (srm > 41) {
            return colors[colors.length - 1];
        } else {
            return colors[srm - 1];
        }
    },

    litersLabel: function litersLabel(isMetric) {
        return isMetric ? "L" : "gal";
    },

    kgLabel: function kgLabel(isMetric) {
        return isMetric ? "kg" : "lb";
    },

    gramLabel: function gramLabel(isMetric) {
        return isMetric ? "g" : "oz";
    },
    tempLabel: function tempLabel(isMetric) {
        return isMetric ? "°C" : "°F";
    },
    toC: function toC(f) {
        if (!f) return 0;

        return utils.safeRound((f - 32) * 5 / 9, 10);
    },
    toF: function toF(c) {
        if (!c) return 0;

        return utils.safeRound(c * 9 / 5 + 32, 10);
    },
    toGrams: function toGrams(oz) {
        if (!oz) return 0;

        return oz * 28.3495;
    },
    toOz: function toOz(g) {
        if (!g) return 0;

        return g / 28.3495;
    },
    toKg: function toKg(lb) {
        if (!lb) return 0;

        return lb / 2.2046;
    },
    toLb: function toLb(kg) {
        if (!kg) return 0;

        return kg * 2.2046;
    },
    toGal: function toGal(l) {
        if (!l) return 0;

        return l * 0.264172;
    },
    toLiters: function toLiters(gal) {
        if (!gal) return 0;

        return gal / 0.264172;
    },
    toGalPerLb: function toGalPerLb(l) {
        if (!l) return 0;

        return l * 0.119826;
    },
    toLPerKg: function toLPerKg(gal) {
        if (!gal) return 0;

        return gal / 0.119826;
    },
    toLbString(kg) {

        const lb = common.round(common.kgToPounds(kg), 4);
        const ounces = (lb - Math.floor(lb)) * 16;
        const pounds = Math.floor(lb);

        if (pounds <= 0) {
            return `${ounces.toFixed(2)} oz`;
        }

        if (pounds > 0 && ounces > 0) {
            return `${pounds.toFixed(0)} lb. ${ounces.toFixed(2)} oz.`;
        }

        return `${pounds.toFixed(2)} lb.`;
    },
    toKgString(kg) {

        if (kg <= 0.25) {
            return `${(kg * 1000).toFixed(2)} g`;
        }

        return `${kg.toFixed(2)} kg`;
    },
    toGalString(liter) {

        const gals = common.litersToGallons(liter);

        if (gals > 1.0) {
            return `${gals.toFixed(2)} gals`;
        } else if (gals > 0.5) {
            return `${gals.toFixed(2)} gal`;
        }

        const oz = common.litersToOunces(liter);

        return `${oz.toFixed(2)} oz`;

        

    },
    toLiterString(liter) {

        if (liter < 1.0) {
            liter = liter * 1000.0;
            return `${liter.toFixed(2)} ml`;
        }

        return `${liter.toFixed(2)} l`;
    }
};

export default utils;


//////////////////
// WEBPACK FOOTER
// ./src/utils/units.js
// module id = 15
// module chunks = 6 7 8